import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Container, Row, Col } from 'react-bootstrap';

const Links = () => {
  const { t } = useTranslation();
  const [copySuccess, setCopySuccess] = useState(false);

  const copyToClipboard = async (text) => {
    try {
      await navigator.clipboard.writeText(text);
      setCopySuccess(true);
      setTimeout(() => setCopySuccess(false), 2000); // Reset after 2 seconds
    } catch (err) {
      console.error('Failed to copy text: ', err);
    }
  };

  return (
    <div className="links-page">
      <Container className="mt-5 mb-5">
        <Row>
          <Col>
            <h1 className="text-center mb-5">{t('links.title', 'Links')}</h1>
          </Col>
        </Row>
        <Row>
          <Col md={8} className="mx-auto">
            <div className="content-section">
              <div className="text-content">
                <h2 className="mb-4">{t('links.survey.title', 'Survey Links')}</h2>
                <div className="mb-4">
                  <h3 className="h5 mb-3">{t('links.survey.faceToFace', 'Syria Face-to-Face Survey Link')}</h3>
                  <h3 className="h6 mb-3">{t( '(يبدأ الاستبيان عند النقر)')}</h3>

                  <p className="d-flex align-items-center">
                    <a 
                      href="https://harvard.az1.qualtrics.com/jfe/form/SV_aYpo7BnuE04GTjg?Q_Language=AR" 
                      target="_blank" 
                      rel="noopener noreferrer"
                      className="text-decoration-none"
                    >
                      {t('links.survey.faceToFaceLink', 'Syria Face-to-Face Survey')}
                    </a>
                    

                  </p>
                  <h3 className="h6 mb-3">{t( '-----')}</h3>
                </div>

                <div className="mb-4">
                  <h3 className="h5 mb-3">{t('links.survey.submission', 'Suriye Gönderme Bağlantısı')}</h3>
                  <h3 className="h6 mb-3">{t( '(يتم نسخه للإرسال عند النقر)')}</h3>

                  <p className="d-flex align-items-center">
                    <a 
                      href="https://harvard.az1.qualtrics.com/jfe/form/SV_aYpo7BnuE04GTjg?Q_Language=AR&link=karekod" 
                      target="_blank" 
                      rel="noopener noreferrer"
                      className="text-decoration-none"
                    >
                      
                    </a>
                    <button
                      onClick={() => copyToClipboard('https://harvard.az1.qualtrics.com/jfe/form/SV_aYpo7BnuE04GTjg?Q_Language=AR&link=karekod')}
                      className={`btn ms-3 px-3 py-1 rounded-pill ${copySuccess ? 'btn-success' : 'btn-outline-primary'}`}
                      style={{
                        border: '1px solid #ad1445',
                        color: copySuccess ? '#fff' : '#ad1445',
                        backgroundColor: copySuccess ? '#ad1445' : 'transparent',
                        transition: 'all 0.3s ease',
                        fontSize: '0.9rem',
                        fontWeight: '500'
                      }}
                      onMouseOver={(e) => {
                        if (!copySuccess) {
                          e.currentTarget.style.backgroundColor = '#ad1445';
                          e.currentTarget.style.color = '#fff';
                        }
                      }}
                      onMouseOut={(e) => {
                        if (!copySuccess) {
                          e.currentTarget.style.backgroundColor = 'transparent';
                          e.currentTarget.style.color = '#ad1445';
                        }
                      }}
                    >
                      {copySuccess ? '✓ تم نسخ الرابط، يمكنكم مشاركته' : '📋 انسخ الرابط'}
                    </button>
                  </p>
                  <h3 className="h6 mb-3">{t( '-----')}</h3>
                </div>
                <div className="mb-4">
                  <h3 className="h5 mb-3">{t('links.survey.tester', 'Survey Tester Link')}</h3>
                  <h3 className="h6 mb-3">{t( '(يبدأ الاستبيان عند النقر)')}</h3>

                  <p>
                    <a 
                      href="https://harvard.az1.qualtrics.com/jfe/form/SV_aYpo7BnuE04GTjg?Q_Language=AR&link=test" 
                      target="_blank" 
                      rel="noopener noreferrer"
                      className="text-decoration-none"
                    >
                      {t('links.survey.testerLink', 'Survey Tester')}
                    </a>
                  </p>
                </div>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Links; 